<template>
  <div class="customer">
    <div class="banner">
      <div class="banner-img">
        <img src="../assets/img/top2.png" />
      </div>
      <div class="banner-title">
        <p>{{this.$root.language == 1?'聚焦客户 合作共赢':'Focus on win-win cooperation with customers'}}</p>
        <!-- <p>企业目标：引领行业发展，为客户提供最佳解决方案，安仑值得信赖。</p> -->
      </div>
    </div>
    <div class="content" style="height: 40vh;">
      <!-- <div class="top">聚焦客户 合作共赢</div> -->
      <h3>{{this.$root.language == 1?'企业目标：引领行业发展，为客户提供最佳解决方案，安仑值得信赖。':'Enterprise Goal:  Be the leader of industrial advancement and provide best solutions to customers.  Anlun is trustworthy.'}}</h3>
      <!-- <div class="content-partner">
        <div class="top">
          <h3 class="wow animate__animated animate__fadeInUp" style="text-align: center;">合作伙伴</h3>
          <p class="wow animate__animated animate__fadeInUp" style="text-align: center;">PARTNERS</p>
          <div class="partnerImg" style="width: 100%; margin: 0 auto">
            <img src="../assets/img/customer.png" style="width: 100%" />
          </div>
        </div>
      </div> -->
      <div class="bottom" style="margin-top: 30px;">
        
        <el-row>
          <el-col :span="12">
            <h3>{{this.$root.language == 1?'联系我们：':'Contact us：'}}</h3>
            <div class="telephone" style="margin-left: 50px; padding-left: 10px; font-size: 18px;padding-top: 50px;padding-bottom: 50px">
              <p>{{this.$root.language == 1?'山西安仑化工有限公司':'Shanxi Anlun Chemical Company Ltd'}}</p>
              <p>{{this.$root.language == 1?'山西地址：山西省运城市河津市僧楼镇河津经济技术开发区东区（华泰西路以东，稷西路以北）':'Shanxi Address: eastern area of Hejin Economic and Technological Development Zone, Senglou Town, Hejin City, Yuncheng City, Shanxi Province (east of Huatai West Road and north of Jixi Road)'}}</p>
              <p>{{this.$root.language == 1?'上海地址：上海市浦东新区王桥路999号1024幢':'Shanghai address: Building 1024, 999 Wangqiao Road, Pudong, Shanghai'}}</p>
              <p><span>{{this.$root.language == 1?'电话：':'Tel: '}}</span><span>021-50799991</span></p>
              <p><span>{{this.$root.language == 1?'邮箱：':'Email:'}}</span><span>anlun@sxygjh.com</span></p>
              <div class="remark" style=" padding: 10px 0">
                {{this.$root.language == 1?'周一至周五（法定节假日除外）9:00-17:00':'Monday to Friday (excluding legal holidays) 9:00-17:00'}}
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <!-- <div class="erweima">
              扫一扫，关注安仑微信公众号：<img style="width: 30%;"
                src="../assets/img/erweima.png"
              />
            </div> -->
            <img src="../assets/img/shal.jpg" style="width: 100%;margin-top: 50px;"/>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 300px;
  display: flex;
  position: relative;
  overflow: hidden;
  img {
    position: absolute;
    height: 100%;
    width: 100%;
  }
  &-title {
    position: absolute;
    color: #ffffff;
    font-size: 45px;
    font-weight: 400;
    line-height: 300px;
    text-align: center;
    width: 100%;
  }
}
.customer {
  .content {
    width: 60%;
    margin: 2% 20%;
    .top {
      padding: 20px 10px;
      font-size: 36px;
    }
    .content-partner {
      padding: 50px 0;
      .partner-img {
        width: 950px;
        margin: 20px auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        li {
          width: 107px;
          height: 107px;
          list-style: none;
          margin: 10px 25px;

          img {
            width: 100%;
            height: 100%;
            border: 1px solid rgb(194, 218, 235);
          }
        }
      }
    }
    .center {
      padding: 20px 10px;
      font-size: 24px;
    }
  }
}
</style>